import React, { useState } from 'react';
import { registerEmpleadoService } from "../../services/registerEmpleado";
import { empleadoSchema } from '../../utils/validation';
import FieldError from '../../utils/FieldError';

const RegisterEmpleadoForm = ({ onVolver }) => {
    const [form, setForm] = useState({ email: '', dni: '', password: '', firstName: '', lastName: '' });
    const [errors, setErrors] = useState({});
    const [mensaje, setMensaje] = useState('');
    const [exito, setExito] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = empleadoSchema.safeParse(form);
        if (!result.success) {
            const fieldErrors = {};
            result.error.issues.forEach((i) => { fieldErrors[i.path[0]] = i.message; });
            setErrors(fieldErrors);
            return;
        }
        const res = await registerEmpleadoService(result.data);
        setMensaje(res.mensaje || "Registro exitoso");
        setExito(res.success);
        if (res.success) {
            setForm({ email: '', dni: '', password: '', firstName: '', lastName: '' });
            setErrors({});
        }
        setTimeout(() => { setMensaje(''); setExito(null); }, 5000);
    };

    const fields = [
        { name: 'email', type: 'email', placeholder: 'Correo' },
        { name: 'dni', type: 'text', placeholder: 'DNI' },
        { name: 'password', type: 'password', placeholder: 'Contraseña' },
        { name: 'firstName', type: 'text', placeholder: 'Nombre' },
        { name: 'lastName', type: 'text', placeholder: 'Apellido' },
    ];

    return (
        <div className="max-w-md mx-auto">
            <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-lg shadow-sm p-8 space-y-5">
                <h2 className="text-xl font-semibold text-gray-900 text-center">Registrar Empleado</h2>
                <div className="space-y-4">
                    {fields.map((f) => (
                        <div key={f.name}>
                            <input name={f.name} type={f.type} placeholder={f.placeholder} value={form[f.name]} onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                            <FieldError message={errors[f.name]} />
                        </div>
                    ))}
                </div>
                <button type="submit" className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors">Registrar</button>
                {mensaje && <p className={`text-sm text-center font-medium ${exito ? 'text-green-600' : 'text-red-600'}`}>{mensaje}</p>}
            </form>
            <button type="button" onClick={onVolver}
                className="w-full mt-3 py-2.5 px-4 bg-gray-500 text-white text-sm font-medium rounded-md hover:bg-gray-600 transition-colors">
                Volver
            </button>
        </div>
    );
};

export default RegisterEmpleadoForm;
